import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation, useParams, Link } from 'react-router-dom';
import {
  Button, Checkbox, CircularProgress, FormControlLabel, Grid, IconButton, MenuItem, Paper,
  Radio, RadioGroup, TextField, Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import { showNotification } from 'store/actions/notifications';
import { NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_SUCCESS } from 'constants/notification';
import { UserContext } from 'contexts/user';
import * as api from './api';
import Etiqueta from './Etiqueta';

// Proposta dinâmica (24/10/2026). Aberta pelo campo "Link proposta" do
// Pipedrive: /propostas/nova?negocio=<dealId>. Edição: /propostas/:id/editar
// (nova versão no mesmo link). A conta é sempre da api (/propostas/calcular);
// a prévia à direita é a própria página do cliente (cj-proposta /preview).
//
// 29/10/2026 (pedidos dos vendedores): até 3 cenários por proposta, um
// recomendado; forma de pagamento composta (entrada no Pix + parcelas no
// cartão ou boleto, com ou sem juros) e simulador para o cliente; desconto
// fixo de cliente da casa; serviços avulsos (pré-busca); valor por pessoa;
// minuta em branco; "Virar venda".
//
// 04/11/2026: Black November CJ (até 13/11): frente da campanha no cenário
// (2ª venda 50%, indicação e outros 40%, Análise 50%). Na Assessoria
// completa só à vista ou com juros; o desconto é da campanha (fora da alçada).

const useStyles = makeStyles((theme) => ({
  pagina: { maxWidth: 1240, margin: '0 auto', padding: '20px 16px 64px' },
  grade: { display: 'grid', gridTemplateColumns: '1fr', gap: 20, [theme.breakpoints.up('md')]: { gridTemplateColumns: 'minmax(0,1fr) 380px', alignItems: 'start' } },
  card: { padding: 16, borderRadius: 12, marginBottom: 14, border: '1px solid #E4E3E9' },
  tituloCard: { fontSize: 13, letterSpacing: '.1em', textTransform: 'uppercase', color: '#1F9833', fontWeight: 900, margin: '0 0 10px' },
  dica: { fontSize: 12.5, color: '#64688B', margin: '8px 0 0' },
  req: { display: 'grid', gridTemplateColumns: 'minmax(0,1.1fr) minmax(0,.7fr) minmax(0,1.6fr) minmax(0,1fr) auto', gap: 8, alignItems: 'end', paddingBottom: 6, borderBottom: '1px dashed #E4E3E9', marginBottom: 8, [theme.breakpoints.down('sm')]: { gridTemplateColumns: '1fr 1fr' } },
  taxa: { gridColumn: '1/-1', fontSize: 12, color: '#64688B' },
  planos: { display: 'grid', gridTemplateColumns: '1fr', gap: 8, [theme.breakpoints.up('sm')]: { gridTemplateColumns: '1fr 1fr 1fr' } },
  plano: { border: '1px solid #E4E3E9', borderRadius: 10, padding: '8px 10px', margin: 0, alignItems: 'flex-start' },
  planoAtivo: { borderColor: '#1F9833', background: '#E8F5EA' },
  totais: { display: 'flex', flexDirection: 'column', gap: 4, marginTop: 12, fontSize: 14, fontVariantNumeric: 'tabular-nums' },
  linha: { display: 'flex', justifyContent: 'space-between', gap: 12 },
  grande: { fontSize: 18, fontWeight: 900, borderTop: '1px solid #E4E3E9', paddingTop: 6, marginTop: 4 },
  secao: { marginTop: 10, fontSize: 12, letterSpacing: '.08em', textTransform: 'uppercase', color: '#64688B', fontWeight: 700 },
  acoes: { display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 14, alignItems: 'center' },
  linkbox: { marginTop: 12, background: '#E8F5EA', borderRadius: 10, padding: 12 },
  codigo: { display: 'block', fontFamily: 'ui-monospace,Menlo,monospace', fontSize: 13, wordBreak: 'break-all', background: '#fff', padding: '8px 10px', borderRadius: 6, margin: '6px 0 10px', border: '1px solid #E4E3E9' },
  previa: { position: 'sticky', top: 80 },
  celular: { margin: '0 auto', width: '100%', maxWidth: 360, background: '#fff', border: '8px solid #22252E', borderRadius: 32, overflow: 'hidden', boxShadow: '0 20px 50px rgba(0,0,0,.18)', height: 680 },
  aviso: { background: '#FFF4DD', borderRadius: 8, padding: '8px 12px', fontSize: 13.5, marginTop: 10 },
  abas: { display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center', marginBottom: 10 },
  aba: { border: '1px solid #E4E3E9', borderRadius: 999, padding: '6px 14px', background: '#fff', cursor: 'pointer', font: 'inherit', fontSize: 13.5, fontWeight: 700, color: '#42455F' },
  abaAtiva: { borderColor: '#1F9833', background: '#E8F5EA', color: '#1F9833' },
  interno: { marginTop: 10, background: '#F9F8F9', borderRadius: 8, padding: '8px 12px', fontSize: 13, color: '#42455F', border: '1px dashed #E4E3E9' },
  liberadas: { display: 'grid', gridTemplateColumns: '1fr', gap: 6, marginTop: 6, [theme.breakpoints.up('sm')]: { gridTemplateColumns: '1fr 1fr' } },
  liberada: { display: 'flex', alignItems: 'center', gap: 6, fontSize: 13.5 },
  campanha: { marginTop: 10, background: '#14142A', color: '#fff', borderRadius: 10, padding: '10px 12px', fontSize: 13.5, '& .MuiFormControlLabel-label': { fontSize: 13.5 }, '& .MuiRadio-root': { color: '#FFD84D' }, '& small': { color: '#E4E3E9 !important' } },
  campanhaTitulo: { fontWeight: 900, letterSpacing: '.04em', color: '#FFD84D' },
}));

const MEIOS = [
  { valor: 'pix', rotulo: 'À vista no Pix' },
  { valor: 'cartao', rotulo: 'Cartão de crédito' },
  { valor: 'boleto', rotulo: 'Boleto' },
];
const JUROS = [
  { valor: 'cj', rotulo: 'Sem juros (a CJ absorve, conta na alçada)' },
  { valor: 'cliente', rotulo: 'Com juros (o cliente paga)' },
];
const LIBERAVEIS = [
  { chave: 'pix:cj', meio: 'pix', juros: 'cj', rotulo: 'À vista no Pix' },
  { chave: 'cartao:cj', meio: 'cartao', juros: 'cj', rotulo: 'Cartão sem juros' },
  { chave: 'cartao:cliente', meio: 'cartao', juros: 'cliente', rotulo: 'Cartão com juros' },
  { chave: 'boleto:cj', meio: 'boleto', juros: 'cj', rotulo: 'Boleto sem juros' },
  { chave: 'boleto:cliente', meio: 'boleto', juros: 'cliente', rotulo: 'Boleto com juros' },
];

const novoRequerente = (produtoId) => ({ nome: '', menor: false, produto_id: produtoId || '', depende_de: null });
const novoCenario = (produtoId, titulo, nome) => ({
  titulo: titulo || '',
  plano: '2026',
  requerentes: [{ ...novoRequerente(produtoId), nome: nome || '' }],
  avulsos: [],
  desconto: '0',
  clienteExistente: false,
  campanha: '',
  exibicao: 'total',
  pagamento: { meio: 'cartao', parcelas: 12, juros: 'cj', entrada: '', simulador: true, liberadas: ['pix:cj', 'cartao:cj', 'cartao:cliente', 'boleto:cliente'], maximos: {} },
  valorPago: '',
  dataLaudo: '',
});

/** Input da api (cenário) → estado da tela. Aceita o formato antigo (sem cenários). */
const doInput = (inp) => {
  const pg = inp.pagamento || { meio: inp.parcelas > 1 ? 'cartao' : 'pix', parcelas: inp.parcelas || 1, juros: 'cj', entrada_centavos: 0, simulador: false, liberadas: [] };
  const maximos = {};
  (pg.liberadas || []).forEach((l) => { maximos[`${l.meio}:${l.juros || 'cj'}`] = l.parcelas_max; });
  return {
    titulo: inp.titulo || '',
    plano: inp.plano || '2026',
    requerentes: (inp.requerentes || []).map((r) => ({ ...r, depende_de: r.depende_de === undefined ? null : r.depende_de })),
    avulsos: (inp.avulsos || []).map((a) => ({ produto_id: a.produto_id, quantidade: a.quantidade || 1 })),
    desconto: String(inp.desconto_pct || 0),
    clienteExistente: Boolean(inp.cliente_existente),
    campanha: inp.campanha || '',
    exibicao: inp.exibicao || 'total',
    pagamento: {
      meio: pg.meio || 'pix',
      parcelas: pg.parcelas || 1,
      juros: pg.juros || 'cj',
      entrada: pg.entrada_centavos ? String(pg.entrada_centavos / 100).replace('.', ',') : '',
      simulador: Boolean(pg.simulador),
      liberadas: (pg.liberadas || []).map((l) => `${l.meio}:${l.meio === 'pix' ? 'cj' : (l.juros || 'cj')}`),
      maximos,
    },
    valorPago: inp.continuacao && inp.continuacao.valor_pago_centavos ? String(inp.continuacao.valor_pago_centavos / 100) : '',
    dataLaudo: (inp.continuacao && inp.continuacao.data_laudo) || '',
    analiseCampanha: Boolean(inp.continuacao && inp.continuacao.campanha),
  };
};

/** Estado da tela (cenário) → input da api. */
const paraApi = (c, maxParcelas) => ({
  titulo: c.titulo,
  plano: c.plano,
  requerentes: c.plano === 'avulso' ? [] : c.requerentes.map((r) => ({ ...r, produto_id: Number(r.produto_id) || 0 })),
  avulsos: c.avulsos.map((a) => ({ produto_id: Number(a.produto_id), quantidade: Number(a.quantidade) || 1 })),
  desconto_pct: String(c.desconto).replace(',', '.') || 0,
  cliente_existente: c.campanha ? false : c.clienteExistente,
  campanha: c.campanha || null,
  exibicao: c.exibicao,
  pagamento: {
    meio: c.pagamento.meio,
    parcelas: c.pagamento.meio === 'pix' ? 1 : Number(c.pagamento.parcelas) || 1,
    juros: c.pagamento.juros,
    entrada_centavos: api.paraCentavos(c.pagamento.entrada),
    simulador: c.pagamento.simulador,
    liberadas: c.pagamento.liberadas.map((chave) => {
      const [meio, juros] = chave.split(':');
      return { meio, juros, parcelas_max: c.pagamento.maximos[chave] || (maxParcelas || {})[meio] || 1 };
    }),
  },
  continuacao: {
    valor_pago_centavos: api.paraCentavos(c.valorPago),
    data_laudo: c.dataLaudo || null,
    campanha: Boolean(c.analiseCampanha),
  },
});

function NovaProposta({ notify }) {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams();
  const { user } = React.useContext(UserContext);
  const iframe = useRef(null);
  const ultimaPagina = useRef(null);

  const [carregando, setCarregando] = useState(true);
  const [erroCarga, setErroCarga] = useState('');
  const [cat, setCat] = useState(null);
  const [deal, setDeal] = useState(null);
  const [existentes, setExistentes] = useState([]);
  const [analise, setAnalise] = useState(null);
  const [proposta, setProposta] = useState(null);
  const [dealDigitado, setDealDigitado] = useState('');

  const [cenarios, setCenarios] = useState([]);
  const [ativo, setAtivo] = useState(0);
  const [recomendado, setRecomendado] = useState(0);
  const [validade, setValidade] = useState(7);
  const [observacoes, setObservacoes] = useState('');

  const [calculo, setCalculo] = useState(null);
  const [erros, setErros] = useState({});
  const [salvando, setSalvando] = useState(false);
  const [copiado, setCopiado] = useState('');

  const dealId = useMemo(() => new URLSearchParams(location.search).get('negocio'), [location.search]);
  const produtos = (cat && cat.produtos) || [];
  const avulsosCat = (cat && cat.avulsos) || [];
  const maxParcelas = (cat && cat.max_parcelas) || { pix: 1, cartao: 21, boleto: 24 };
  const produtoDe = (pid) => produtos.find((p) => p.id === Number(pid));
  const produtoPadrao = (c) => (c.produtos.find((p) => /simples/i.test(p.titulo)) || c.produtos[0] || {}).id;

  const c = cenarios[ativo] || null;
  const calcAtivo = calculo && calculo.cenarios && calculo.cenarios[ativo] ? calculo.cenarios[ativo].calculo : calculo;

  // Carga: catálogo + negócio (nova) ou proposta (edição).
  useEffect(() => {
    let vivo = true;
    (async () => {
      setCarregando(true);
      setErroCarga('');
      try {
        const cg = await api.catalogo();
        if (!vivo) return;
        setCat(cg);
        if (id) {
          const d = await api.detalhe(id);
          if (!vivo) return;
          aplicarDetalhe(d);
        } else if (dealId) {
          const n = await api.negocio(dealId);
          if (!vivo) return;
          setDeal(n.deal);
          setExistentes(n.propostas || []);
          setAnalise(n.analise);
          setCenarios([novoCenario(produtoPadrao(cg), '', ((n.deal.person && n.deal.person.name) || '').split(' ')[0])]);
        } else {
          setCenarios([novoCenario(produtoPadrao(cg))]);
        }
      } catch (e) {
        if (vivo) setErroCarga(api.mensagemDoErro(e));
      } finally {
        if (vivo) setCarregando(false);
      }
    })();
    return () => { vivo = false; };
    // eslint-disable-next-line
  }, [id, dealId]);

  const aplicarDetalhe = (d) => {
    const p = d.proposta;
    setProposta(p);
    setDeal({ deal_id: p.negocio, title: p.deal_title, pt: p.pt, person: { name: p.cliente, email: p.client_email, phone: p.client_phone } });
    const inp = d.versao_atual && d.versao_atual.input;
    if (inp) {
      const lista = inp.cenarios && inp.cenarios.length ? inp.cenarios : [inp];
      setCenarios(lista.map((x) => doInput(x)));
      setRecomendado(inp.recomendado || 0);
      setAtivo((a) => Math.min(a, lista.length - 1));
      setValidade(inp.validade_dias || 7);
      setObservacoes(inp.observacoes || '');
    }
  };

  // Continuação: pré-preenche com a venda do Plano Análise do mesmo PT.
  useEffect(() => {
    if (c && c.plano === 'continuacao' && analise && !c.valorPago && !c.dataLaudo) {
      mudarCenario({ valorPago: String((analise.valor_pago_centavos || 0) / 100), dataLaudo: analise.data_laudo || '', analiseCampanha: Boolean(analise.campanha) });
    }
    // eslint-disable-next-line
  }, [c && c.plano, analise]);

  const corpo = useCallback(() => ({
    cenarios: cenarios.map((x) => paraApi(x, maxParcelas)),
    recomendado,
    validade_dias: validade,
    observacoes,
    cliente_nome: deal && deal.person ? deal.person.name : null,
  }), [cenarios, recomendado, validade, observacoes, deal, maxParcelas]);

  const enviarPrevia = useCallback((pagina) => {
    ultimaPagina.current = pagina;
    if (iframe.current && iframe.current.contentWindow && pagina && cat) {
      iframe.current.contentWindow.postMessage({ type: 'cjp-previa', pagina }, cat.url_publica);
    }
  }, [cat]);

  // Conta ao vivo (api), com espera curta enquanto digita.
  useEffect(() => {
    if (!cat || !cenarios.length) return undefined;
    const t = setTimeout(async () => {
      try {
        const r = await api.calcular(corpo());
        setCalculo(r.calculo);
        setErros(r.erros || {});
        enviarPrevia(r.pagina);
      } catch (e) { /* mantém a última conta */ }
    }, 350);
    return () => clearTimeout(t);
  }, [cat, cenarios, corpo, enviarPrevia]);

  // O iframe avisa quando está pronto: manda a última prévia.
  useEffect(() => {
    const aoReceber = (e) => {
      if (cat && e.origin === cat.url_publica && e.data && e.data.type === 'cjp-pronto' && ultimaPagina.current) {
        enviarPrevia(ultimaPagina.current);
      }
    };
    window.addEventListener('message', aoReceber);
    return () => window.removeEventListener('message', aoReceber);
  }, [cat, enviarPrevia]);

  // ---- edição do cenário ativo ----
  const mudarCenario = (patch) => setCenarios((lista) => lista.map((x, i) => (i === ativo ? { ...x, ...patch } : x)));
  const mudarPagamento = (patch) => mudarCenario({ pagamento: { ...c.pagamento, ...patch } });
  // Serviço avulso = um serviço só; busca por genealogistas só existe no avulso (30/10/2026).
  const trocarPlano = (plano) => {
    const soIsolado = (id) => (avulsosCat.find((x) => x.id === Number(id)) || {}).so_isolado;
    // A frente da Black November é de um plano só: trocar de plano tira a campanha.
    if (plano === 'avulso') {
      const primeiro = c.avulsos[0] || (avulsosCat[0] && { produto_id: avulsosCat[0].id, quantidade: 1 });
      mudarCenario({ plano, campanha: '', avulsos: primeiro ? [primeiro] : [] });
    } else {
      mudarCenario({ plano, campanha: '', avulsos: c.avulsos.filter((a) => !soIsolado(a.produto_id)) });
    }
  };

  // Black November CJ: na Assessoria completa o "sem juros" sai (fica o Pix e o "com juros").
  const escolherCampanha = (campanha) => {
    if (!campanha || c.plano !== '2026') {
      mudarCenario({ campanha });
      return;
    }
    const liberadas = c.pagamento.liberadas.filter((k) => k.startsWith('pix:') || k.endsWith(':cliente'));
    mudarCenario({ campanha, pagamento: { ...c.pagamento, juros: 'cliente', liberadas } });
  };
  const mudarReq = (i, campo, valor) => mudarCenario({
    requerentes: c.requerentes.map((r, j) => {
      if (j !== i) return r;
      const novo = { ...r, [campo]: valor };
      if (campo === 'produto_id') {
        const p = produtoDe(valor);
        if (p && p.menor) novo.menor = true;
      }
      return novo;
    }),
  });
  const removerReq = (i) => mudarCenario({
    requerentes: c.requerentes
      .filter((_, j) => j !== i)
      .map((r) => {
        if (r.depende_de === i) return { ...r, depende_de: null };
        if (r.depende_de !== null && r.depende_de > i) return { ...r, depende_de: r.depende_de - 1 };
        return r;
      }),
  });
  const nomeDe = (r, i) => (r.nome || '').trim() || `Requerente ${i + 1}`;

  const adicionarCenario = () => {
    if (cenarios.length >= (cat.max_cenarios || 3)) return;
    const base = cenarios[ativo];
    const copia = JSON.parse(JSON.stringify(base));
    copia.titulo = '';
    setCenarios((l) => [...l, copia]);
    setAtivo(cenarios.length);
  };
  const removerCenario = (i) => {
    if (cenarios.length <= 1) return;
    const lista = cenarios.filter((_, j) => j !== i);
    setCenarios(lista);
    setAtivo(Math.max(0, Math.min(ativo, lista.length - 1) - (i < ativo ? 1 : 0)));
    setRecomendado((r) => (r === i ? 0 : r > i ? r - 1 : r));
  };

  const alternarLiberada = (chave) => {
    const tem = c.pagamento.liberadas.includes(chave);
    mudarPagamento({ liberadas: tem ? c.pagamento.liberadas.filter((k) => k !== chave) : [...c.pagamento.liberadas, chave] });
  };

  const salvar = async (gerarLink) => {
    if (!deal) {
      notify(NOTIFICATION_TYPE_ERROR, 'Abra a proposta a partir do número do negócio.');
      return;
    }
    setSalvando(true);
    try {
      const body = { ...corpo(), gerar: gerarLink };
      const r = proposta
        ? await api.salvarVersao(proposta.id, body)
        : await api.criar({ ...body, deal_id: deal.deal_id });
      aplicarDetalhe(r);
      notify(NOTIFICATION_TYPE_SUCCESS, r.message || 'Salvo');
      if (!proposta) history.replace(`/propostas/${r.proposta.id}/editar`);
    } catch (e) {
      notify(NOTIFICATION_TYPE_ERROR, api.mensagemDoErro(e));
    } finally {
      setSalvando(false);
    }
  };

  const aprovarDesconto = async () => {
    setSalvando(true);
    try {
      aplicarDetalhe(await api.aprovar(proposta.id));
      notify(NOTIFICATION_TYPE_SUCCESS, 'Desconto aprovado e link publicado');
    } catch (e) {
      notify(NOTIFICATION_TYPE_ERROR, api.mensagemDoErro(e));
    } finally {
      setSalvando(false);
    }
  };

  const virarVenda = async (clientId) => {
    setSalvando(true);
    try {
      const r = await api.virarVenda(proposta.id, clientId ? { client_id: clientId } : {});
      notify(NOTIFICATION_TYPE_SUCCESS, r.message || 'Venda criada');
      history.push(`/nova-venda/${r.venda.id}`);
    } catch (e) {
      const d = e && e.response && e.response.data;
      if (d && d.precisa_pt) {
        const pt = window.prompt('O negócio não tem PT na organização do Pipedrive. Informe o PT da venda:');
        if (pt && pt.trim()) {
          setSalvando(false);
          virarVenda(pt.trim());
          return;
        }
      }
      notify(NOTIFICATION_TYPE_ERROR, api.mensagemDoErro(e));
    } finally {
      setSalvando(false);
    }
  };

  const copiar = (texto, rotulo) => {
    const ok = () => { setCopiado(`${rotulo} copiado.`); setTimeout(() => setCopiado(''), 2500); };
    if (navigator.clipboard) navigator.clipboard.writeText(texto).then(ok).catch(() => setCopiado('Selecione e copie o texto acima.'));
  };

  const abrirMinuta = async () => {
    try {
      await api.abrirMinuta(c.plano);
    } catch (e) {
      notify(NOTIFICATION_TYPE_ERROR, 'Não foi possível abrir a minuta.');
    }
  };

  if (carregando) {
    return <div className={classes.pagina}><CircularProgress size={28} /> Carregando…</div>;
  }

  if (!deal && !id) {
    return (
      <div className={classes.pagina}>
        <Typography variant="h5" style={{ fontWeight: 900 }}>Nova proposta</Typography>
        {erroCarga && <p style={{ color: '#DB0A3C' }}>{erroCarga}</p>}
        <Paper className={classes.card} elevation={0}>
          <h3 className={classes.tituloCard}>Negócio</h3>
          <form onSubmit={(e) => { e.preventDefault(); const n = dealDigitado.replace(/\D/g, ''); if (n) history.push(`/propostas/nova?negocio=${n}`); }}>
            <Grid container spacing={2} alignItems="flex-end">
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Número do negócio (ID do Pipedrive)" value={dealDigitado} onChange={(e) => setDealDigitado(e.target.value)} inputProps={{ inputMode: 'numeric' }} />
              </Grid>
              <Grid item><Button type="submit" variant="contained" color="primary">Buscar</Button></Grid>
            </Grid>
          </form>
          <p className={classes.dica}>No Pipedrive, o campo "Link proposta" do negócio abre esta tela já com o negócio carregado.</p>
        </Paper>
      </div>
    );
  }

  if (erroCarga || !c) {
    return (
      <div className={classes.pagina}>
        <Typography variant="h5" style={{ fontWeight: 900 }}>Nova proposta</Typography>
        <p style={{ color: '#DB0A3C' }}>{erroCarga || 'Proposta sem cenários.'}</p>
        <Button component={Link} to="/propostas/nova">Tentar outro negócio</Button>
      </div>
    );
  }

  const h = calcAtivo && calcAtivo.honorarios;
  const pg = h && h.pagamento;
  const etapas = calcAtivo ? calcAtivo.linha_do_tempo.filter((e) => e.codigo !== 'assinatura') : [];
  const max = cat ? cat.desconto_max_vendedor : 5;
  const alcadaUsada = calculo ? calculo.alcada_usada_pct : 0;
  const acimaDaAlcada = calculo ? calculo.precisa_aprovacao : false;
  // Análise não tem alçada (founder, 03/11/2026): desconto e sem juros sem aprovação.
  const semAlcada = c && c.plano === 'analise';
  const coordenador = cat && cat.coordenador;
  const link = proposta && proposta.link;
  const mesesAbatimento = (cat && cat.meses_abatimento) || 3;
  const desconto2v = (cat && cat.desconto_2v) || 10;
  const campanhaCat = cat && cat.campanha;
  const frentesDoPlano = campanhaCat && campanhaCat.ativa ? (campanhaCat.frentes || []).filter((f) => f.plano === c.plano) : [];
  const frente = campanhaCat && c.campanha ? (campanhaCat.frentes || []).find((f) => f.codigo === c.campanha) : null;
  const semJurosBloqueado = Boolean(frente && c.plano === '2026');
  const ateCampanha = campanhaCat ? new Date(campanhaCat.ate).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }) : '';
  const erroDe = (campo) => erros[`cenarios.${ativo}.${campo}`] || erros[campo];
  const parcelasPossiveis = Array.from({ length: maxParcelas[c.pagamento.meio] || 1 }, (_, i) => i + 1);

  return (
    <div className={classes.pagina}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, flexWrap: 'wrap' }}>
        <Typography variant="h5" style={{ fontWeight: 900 }}>
          {proposta ? `Proposta nº ${proposta.numero}` : 'Nova proposta'}
        </Typography>
        {proposta && <Etiqueta status={proposta.status} />}
        {proposta && <span style={{ color: '#64688B', fontSize: 13 }}>versão {proposta.versao_atual}{proposta.versao_publicada ? ` · cliente vê a versão ${proposta.versao_publicada}` : ''}</span>}
        <Link to="/propostas" style={{ marginLeft: 'auto', fontSize: 14 }}>Minhas propostas</Link>
      </div>
      <p style={{ color: '#64688B', margin: '4px 0 16px', maxWidth: '75ch' }}>
        Honorários pela regra do plano; certidões e vale postal ficam fora e aparecem numa linha do tempo para o cliente.
      </p>

      <div className={classes.grade}>
        <div>
          <Paper className={classes.card} elevation={0}>
            <h3 className={classes.tituloCard}>Negócio</h3>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}><TextField fullWidth label="Número do negócio" value={deal ? deal.deal_id : ''} InputProps={{ readOnly: true }} /></Grid>
              <Grid item xs={12} sm={8}><TextField fullWidth label="Nome do cliente (Pipedrive)" value={(deal && deal.person && deal.person.name) || ''} InputProps={{ readOnly: true }} /></Grid>
            </Grid>
            {!proposta && existentes.length > 0 && (
              <div className={classes.aviso}>
                Este negócio já tem {existentes.length === 1 ? 'a proposta' : 'as propostas'}{' '}
                {existentes.map((p, i) => (
                  <span key={p.id}>{i ? ', ' : ''}<Link to={`/propostas/${p.id}/editar`}>nº {p.numero}</Link> ({(api.STATUS[p.status] || {}).rotulo})</span>
                ))}
                . Para mudar valores, abra a existente: editar cria uma nova versão no mesmo link.
              </div>
            )}
            {proposta && proposta.escolha && proposta.escolha.resumo && (
              <div className={classes.aviso}>Ao clicar em "Quero contratar", o cliente escolheu: <b>{proposta.escolha.resumo}</b>.</div>
            )}
          </Paper>

          <Paper className={classes.card} elevation={0}>
            <h3 className={classes.tituloCard}>Cenários</h3>
            <div className={classes.abas} role="tablist">
              {cenarios.map((x, i) => (
                <button type="button" role="tab" aria-selected={i === ativo} key={i} className={`${classes.aba} ${i === ativo ? classes.abaAtiva : ''}`} onClick={() => setAtivo(i)}>
                  {x.titulo || `Cenário ${'ABC'[i]}`}{i === recomendado && cenarios.length > 1 ? ' ★' : ''}
                </button>
              ))}
              {cenarios.length < ((cat && cat.max_cenarios) || 3) && !cenarios.some((x) => x.plano === 'analise') && (
                <Button size="small" variant="outlined" onClick={adicionarCenario}>+ Cenário (copia este)</Button>
              )}
              {cenarios.some((x) => x.plano === 'analise') && cenarios.length === 1 && (
                <span style={{ fontSize: 12.5, color: '#64688B' }}>Proposta de Análise tem um cenário só.</span>
              )}
            </div>
            {cenarios.length > 1 && (
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={5}>
                  <TextField fullWidth label="Nome do cenário" placeholder={`Cenário ${'ABC'[ativo]}`} value={c.titulo} onChange={(e) => mudarCenario({ titulo: e.target.value })} inputProps={{ maxLength: 40 }} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControlLabel control={<Radio color="primary" checked={recomendado === ativo} onChange={() => setRecomendado(ativo)} />} label="Recomendado" />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Button size="small" onClick={() => removerCenario(ativo)} style={{ color: '#DB0A3C' }}>Remover cenário</Button>
                </Grid>
              </Grid>
            )}
            <p className={classes.dica}>
              {cenarios.length > 1
                ? 'O cliente vê os cenários lado a lado e o recomendado abre primeiro. Cada cenário tem requerentes, plano, desconto e pagamento próprios.'
                : 'Até 3 cenários por proposta (ex.: quem entra agora, família mínima, família completa). O cliente compara na mesma página.'}
            </p>
          </Paper>

          <Paper className={classes.card} elevation={0}>
            <h3 className={classes.tituloCard}>{c.plano === 'avulso' ? 'Serviço' : 'Requerentes'}{cenarios.length > 1 ? ` · ${c.titulo || `Cenário ${'ABC'[ativo]}`}` : ''}</h3>
            {c.plano !== 'avulso' && c.requerentes.map((r, i) => {
              const p = produtoDe(r.produto_id);
              const dep = r.depende_de !== null && r.depende_de !== undefined ? c.requerentes[r.depende_de] : null;
              return (
                <div className={classes.req} key={i}>
                  <TextField label="Nome (opcional)" placeholder={`Requerente ${i + 1}`} value={r.nome} onChange={(e) => mudarReq(i, 'nome', e.target.value)} />
                  <TextField select label="Idade" value={r.menor ? '1' : '0'} onChange={(e) => mudarReq(i, 'menor', e.target.value === '1')}>
                    <MenuItem value="0">Adulto</MenuItem>
                    <MenuItem value="1">Menor</MenuItem>
                  </TextField>
                  <TextField select label="Processo" value={r.produto_id} onChange={(e) => mudarReq(i, 'produto_id', e.target.value)} error={!!erroDe(`requerentes.${i}.produto_id`)}>
                    {produtos.map((q) => <MenuItem key={q.id} value={q.id}>{q.titulo}</MenuItem>)}
                  </TextField>
                  <TextField select label="Depende de" value={r.depende_de === null || r.depende_de === undefined ? '' : r.depende_de} onChange={(e) => mudarReq(i, 'depende_de', e.target.value === '' ? null : Number(e.target.value))}>
                    <MenuItem value="">—</MenuItem>
                    {c.requerentes.map((o, j) => (j === i ? null : <MenuItem key={j} value={j}>{nomeDe(o, j)}</MenuItem>))}
                  </TextField>
                  <IconButton aria-label="Remover requerente" onClick={() => removerReq(i)} disabled={c.requerentes.length === 1} size="small"><Close /></IconButton>
                  <div className={classes.taxa}>
                    {p ? `Taxas deste processo: certidões ${api.brl(p.certidoes)} · vale postal ${api.brl(p.vale_postal)}${p.outras ? ` · outras taxas ${api.brl(p.outras)}` : ''}` : 'Escolha o processo'}
                    {dep ? <b style={{ color: '#9A6700' }}>{` · futuro, após ${nomeDe(dep, r.depende_de)}`}</b> : null}
                    {p && p.transcricao ? ' · transcrição do próprio português: não conta como adulto' : ''}
                  </div>
                </div>
              );
            })}
            {c.plano !== 'avulso' && (
            <div className={classes.acoes}>
              <Button size="small" variant="outlined" onClick={() => mudarCenario({ requerentes: [...c.requerentes, novoRequerente(produtoPadrao(cat))] })}>+ Adicionar requerente</Button>
            </div>
            )}
            {c.plano !== 'avulso' && <p className={classes.dica}>Nome é opcional; o mesmo nome em duas linhas conta como a mesma pessoa. "Depende de" marca o processo que só começa depois que outro conclui: conta nos honorários, mas as taxas vão para a etapa "Futuro".</p>}

            {avulsosCat.length > 0 && (
              <>
                <div className={`${classes.linha} ${classes.secao}`}>{c.plano === 'avulso' ? 'Proposta só deste serviço (sem requerentes nem processo)' : 'Serviços avulsos somados ao plano (fora do desconto)'}</div>
                {c.avulsos.map((a, i) => {
                  const av = avulsosCat.find((x) => x.id === Number(a.produto_id));
                  return (
                    <Grid container spacing={1} alignItems="center" key={i} style={{ marginTop: 4 }}>
                      <Grid item xs={8} sm={7}>
                        <TextField select fullWidth label="Serviço" value={a.produto_id} onChange={(e) => mudarCenario({ avulsos: c.avulsos.map((x, j) => (j === i ? { ...x, produto_id: Number(e.target.value) } : x)) })}>
                          {avulsosCat.filter((x) => c.plano === 'avulso' || !x.so_isolado).map((x) => <MenuItem key={x.id} value={x.id}>{x.titulo} · {api.brl(x.valor)}</MenuItem>)}
                        </TextField>
                      </Grid>
                      <Grid item xs={3} sm={3}>
                        <TextField select fullWidth label="Qtd." value={a.quantidade} onChange={(e) => mudarCenario({ avulsos: c.avulsos.map((x, j) => (j === i ? { ...x, quantidade: Number(e.target.value) } : x)) })}>
                          {[1, 2, 3, 4, 5].map((n) => <MenuItem key={n} value={n}>{n}</MenuItem>)}
                        </TextField>
                      </Grid>
                      <Grid item xs={1}>
                        <IconButton aria-label="Remover serviço" size="small" disabled={c.plano === 'avulso'} onClick={() => mudarCenario({ avulsos: c.avulsos.filter((_, j) => j !== i) })}><Close /></IconButton>
                      </Grid>
                      {av && <Grid item xs={12}><span className={classes.taxa}>{`${av.titulo}: ${api.brl(av.valor)} × ${a.quantidade} = ${api.brl(av.valor * a.quantidade)}`}</span></Grid>}
                    </Grid>
                  );
                })}
                {c.plano !== 'avulso' && avulsosCat.some((x) => !x.so_isolado) && (
                <div className={classes.acoes} style={{ marginTop: 8 }}>
                  <Button size="small" variant="outlined" onClick={() => mudarCenario({ avulsos: [...c.avulsos, { produto_id: avulsosCat.find((x) => !x.so_isolado).id, quantidade: 1 }] })}>+ Envio de documento português localizado</Button>
                </div>
                )}
                {c.plano !== 'avulso' && <p className={classes.dica}>Busca por genealogistas só é vendida sozinha: escolha o plano "Serviço avulso".</p>}
              </>
            )}
          </Paper>

          <Paper className={classes.card} elevation={0}>
            <h3 className={classes.tituloCard}>Plano</h3>
            <RadioGroup value={c.plano} onChange={(e) => trocarPlano(e.target.value)} className={classes.planos}>
              <FormControlLabel className={`${classes.plano} ${c.plano === '2026' ? classes.planoAtivo : ''}`} value="2026" control={<Radio color="primary" />} label={<span><b>Assessoria completa</b><br /><small>Tabela por adultos; menor paga metade da média. Certidões e vale postal fora.</small></span>} />
              <FormControlLabel className={`${classes.plano} ${c.plano === 'analise' ? classes.planoAtivo : ''}`} value="analise" disabled={cenarios.length > 1} control={<Radio color="primary" />} label={<span><b>Plano Análise</b><br /><small>{cenarios.length > 1 ? 'Análise não tem cenários: deixe um cenário só para escolher.' : 'R$ 1.000 + R$ 500 por requerente adicional. Só certidões; pré-busca à parte.'}</small></span>} />
              <FormControlLabel className={`${classes.plano} ${c.plano === 'continuacao' ? classes.planoAtivo : ''}`} value="continuacao" control={<Radio color="primary" />} label={<span><b>Continuação do processo</b><br /><small>Tabela da assessoria completa com abatimento da análise (laudo com menos de {mesesAbatimento} meses). Só vale postal.</small></span>} />
              <FormControlLabel className={`${classes.plano} ${c.plano === 'avulso' ? classes.planoAtivo : ''}`} value="avulso" control={<Radio color="primary" />} label={<span><b>Serviço avulso</b><br /><small>Só busca por genealogistas ou só envio de documento português localizado, sem processo.</small></span>} />
            </RadioGroup>
            {c.plano === 'continuacao' && (
              <Grid container spacing={2} style={{ marginTop: 6 }}>
                <Grid item xs={12} sm={6}><TextField fullWidth label="Valor pago na análise (R$)" value={c.valorPago} onChange={(e) => mudarCenario({ valorPago: e.target.value })} inputProps={{ inputMode: 'decimal' }} /></Grid>
                <Grid item xs={12} sm={6}><TextField fullWidth type="date" label="Data do laudo" InputLabelProps={{ shrink: true }} value={c.dataLaudo} onChange={(e) => mudarCenario({ dataLaudo: e.target.value })} helperText={`Abate só se o laudo tiver menos de ${mesesAbatimento} meses`} /></Grid>
              </Grid>
            )}
            {c.plano === 'continuacao' && c.analiseCampanha && (
              <div className={classes.campanha}>
                <b>{campanhaCat ? campanhaCat.nome : 'Black November CJ'}:</b> análise vendida na campanha. Abate o valor pago + R$ 2.000 se a continuação for contratada em até {(campanhaCat && campanhaCat.dias_abatimento) || 30} dias do laudo.
              </div>
            )}
            {frentesDoPlano.length > 0 && (
              <div className={classes.campanha}>
                <div className={classes.campanhaTitulo}>{campanhaCat.nome} · até {ateCampanha} · <i>{campanhaCat.slogan}</i></div>
                <RadioGroup row value={c.campanha || ''} onChange={(e) => escolherCampanha(e.target.value)}>
                  <FormControlLabel value="" control={<Radio size="small" />} label="Sem campanha" />
                  {frentesDoPlano.map((f) => (
                    <FormControlLabel key={f.codigo} value={f.codigo} control={<Radio size="small" color="primary" />} label={<span>{f.nome}: <b>−{api.pct(f.desconto_pct)}</b></span>} />
                  ))}
                </RadioGroup>
                <small style={{ color: '#42455F' }}>
                  {c.plano === 'analise'
                    ? 'Continuação contratada em até 30 dias do laudo: abate a análise + R$ 2.000 de desconto.'
                    : 'Desconto da campanha, fora da alçada e sem somar outro desconto. Só à vista ou parcelado com juros. A proposta vence sempre em ' + ateCampanha + '.'}
                </small>
                {erroDe('campanha') && <div style={{ color: '#DB0A3C', fontSize: 13 }}>{erroDe('campanha')}</div>}
              </div>
            )}
            {!c.campanha && (
            <FormControlLabel
              style={{ marginTop: 6 }}
              control={<Checkbox color="primary" checked={c.clienteExistente} onChange={(e) => mudarCenario({ clienteExistente: e.target.checked })} />}
              label={<span>Cliente da casa (2ª venda ou indicação): <b>−{api.pct(desconto2v)}</b> fixo sobre os honorários{semAlcada ? '' : ', dentro da alçada'}</span>}
            />
            )}
          </Paper>

          <Paper className={classes.card} elevation={0}>
            <h3 className={classes.tituloCard}>Honorários e pagamento</h3>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                {frente ? (
                  <TextField fullWidth label="Desconto (%)" value={String(frente.desconto_pct)} disabled helperText={`Desconto da ${campanhaCat.nome}`} />
                ) : (
                  <TextField fullWidth label="Desconto (%)" value={c.desconto} onChange={(e) => mudarCenario({ desconto: e.target.value })} inputProps={{ inputMode: 'decimal' }} helperText={semAlcada ? 'Análise: sem alçada, não vai para aprovação' : `Sua alçada: até ${api.pct(max)} (desconto + juros absorvidos)`} error={!!erroDe('desconto_pct')} />
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField select fullWidth label="Mostrar para o cliente" value={c.exibicao} onChange={(e) => mudarCenario({ exibicao: e.target.value })}>
                  <MenuItem value="total">Valor total da família</MenuItem>
                  <MenuItem value="por_pessoa">Valor por pessoa</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField select fullWidth label="Forma de pagamento" value={c.pagamento.meio} onChange={(e) => mudarPagamento({ meio: e.target.value, parcelas: e.target.value === 'pix' ? 1 : Math.min(c.pagamento.parcelas || 12, maxParcelas[e.target.value] || 1) })}>
                  {MEIOS.map((m) => <MenuItem key={m.valor} value={m.valor}>{m.rotulo}</MenuItem>)}
                </TextField>
              </Grid>
              {c.pagamento.meio !== 'pix' && (
                <>
                  <Grid item xs={12} sm={4}>
                    <TextField select fullWidth label="Parcelas" value={c.pagamento.parcelas} onChange={(e) => mudarPagamento({ parcelas: Number(e.target.value) })} error={!!erroDe('pagamento.parcelas')}>
                      {parcelasPossiveis.map((n) => <MenuItem key={n} value={n}>{n}x</MenuItem>)}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField select fullWidth label="Juros" value={c.pagamento.juros} onChange={(e) => mudarPagamento({ juros: e.target.value })} disabled={Number(c.pagamento.parcelas) <= 1}>
                      {JUROS.filter((j) => !(semJurosBloqueado && j.valor === 'cj')).map((j) => <MenuItem key={j.valor} value={j.valor}>{semAlcada && j.valor === 'cj' ? 'Sem juros (a CJ absorve)' : j.rotulo}</MenuItem>)}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField fullWidth label="Entrada no Pix (R$, opcional)" value={c.pagamento.entrada} onChange={(e) => mudarPagamento({ entrada: e.target.value })} inputProps={{ inputMode: 'decimal' }} helperText="O resto fica parcelado" />
                  </Grid>
                </>
              )}
              <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox color="primary" checked={c.pagamento.simulador} onChange={(e) => mudarPagamento({ simulador: e.target.checked })} />}
                  label="Deixar o cliente simular o pagamento na página (só nas opções abaixo)"
                />
                {c.pagamento.simulador && (
                  <div className={classes.liberadas}>
                    {LIBERAVEIS.filter((l) => !(semJurosBloqueado && l.meio !== 'pix' && l.juros === 'cj')).map((l) => {
                      const ligada = c.pagamento.liberadas.includes(l.chave);
                      return (
                        <div key={l.chave} className={classes.liberada}>
                          <Checkbox color="primary" size="small" checked={ligada} onChange={() => alternarLiberada(l.chave)} />
                          <span>{l.rotulo}</span>
                          {ligada && l.meio !== 'pix' && (
                            <TextField select size="small" value={c.pagamento.maximos[l.chave] || maxParcelas[l.meio]} onChange={(e) => mudarPagamento({ maximos: { ...c.pagamento.maximos, [l.chave]: Number(e.target.value) } })} style={{ width: 90, marginLeft: 'auto' }} label="até">
                              {Array.from({ length: maxParcelas[l.meio] }, (_, i) => i + 1).map((n) => <MenuItem key={n} value={n}>{n}x</MenuItem>)}
                            </TextField>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                {cenarios.some((x) => x.campanha) ? (
                  <TextField fullWidth label="Validade" value={`Até ${ateCampanha}, 23h59`} disabled helperText={`${campanhaCat ? campanhaCat.nome : 'Campanha'}: vence sempre no fim da campanha`} />
                ) : (
                  <TextField fullWidth type="number" label="Validade (dias)" value={validade} onChange={(e) => setValidade(Math.max(1, Math.min(60, Number(e.target.value) || 7)))} helperText="Padrão: 7 dias" />
                )}
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextField fullWidth multiline rows={2} label="Observações para o cliente" value={observacoes} onChange={(e) => setObservacoes(e.target.value)} />
              </Grid>
            </Grid>

            {h && (
              <div className={classes.totais}>
                <div className={classes.linha}><span>Honorários do plano <small style={{ color: '#64688B' }}>({resumoPlano(calcAtivo)})</small></span><span>{api.brl(h.tabela)}</span></div>
                <div className={classes.linha}><span>Desconto {api.pct(h.desconto_pct)}</span><span>−{api.brl(h.desconto)}</span></div>
                {h.desconto_2v > 0 && <div className={classes.linha}><span>Cliente da casa {api.pct(h.desconto_2v_pct)}</span><span>−{api.brl(h.desconto_2v)}</span></div>}
                {h.desconto_campanha > 0 && <div className={classes.linha} style={{ fontWeight: 700 }}><span>{calcAtivo.campanha ? `${calcAtivo.campanha.nome} · ${calcAtivo.campanha.frente_nome}` : 'Campanha'} {api.pct(h.desconto_campanha_pct)}</span><span>−{api.brl(h.desconto_campanha)}</span></div>}
                {h.bonus_campanha > 0 && <div className={classes.linha}><span>Inclui R$ 2.000 da Black November CJ no abatimento</span><span /></div>}
                {c.plano === 'continuacao' && (
                  <div className={classes.linha}>
                    <span>Abatimento da análise {h.abatimento_aplicavel === false ? <small style={{ color: '#DB0A3C' }}>(laudo com mais de {h.dias_abatimento ? `${h.dias_abatimento} dias` : `${mesesAbatimento} meses`} ou sem data: não abate)</small> : null}</span>
                    <span>−{api.brl(h.abatimento)}</span>
                  </div>
                )}
                {h.avulsos > 0 && <div className={classes.linha}><span>Serviços avulsos</span><span>+{api.brl(h.avulsos)}</span></div>}
                <div className={`${classes.linha} ${classes.grande}`}><span>Honorários a pagar</span><span>{api.brl(h.total)}</span></div>
                {pg && (
                  <div className={classes.linha}>
                    <span>Pagamento</span>
                    <span>{pg.descricao}{pg.acrescimo > 0 ? ` · total ${api.brl(pg.total_cliente)}` : ''}</span>
                  </div>
                )}
                {calcAtivo.exibicao === 'por_pessoa' && calcAtivo.por_pessoa.map((pp) => (
                  <div className={classes.linha} key={pp.indice} style={{ color: '#64688B' }}><span>· {pp.nome}</span><span>{api.brl(pp.honorarios)} · {pp.descricao}</span></div>
                ))}
                <div className={`${classes.linha} ${classes.secao}`}>Taxas fora do plano (cliente paga por etapa)</div>
                {etapas.map((e) => (
                  <div className={classes.linha} key={e.codigo} style={e.codigo === 'futuro' ? { color: '#9A6700' } : null}>
                    <span>{e.titulo}{e.codigo === 'futuro' ? ' · após a conclusão de outro requerente' : ''}</span><span>{api.brl(e.total)}</span>
                  </div>
                ))}
                {calcAtivo.interno && (
                  <div className={classes.interno}>
                    <b>Só a equipe vê:</b> líquido para a CJ {api.brl(calcAtivo.interno.liquido)}
                    {calcAtivo.interno.juros_absorvidos > 0 ? ` (juros absorvidos ${api.brl(calcAtivo.interno.juros_absorvidos)}, ${api.pct(calcAtivo.interno.absorvido_pct)})` : ''}
                    {semAlcada ? ' · Análise sem alçada' : <>{' · '}alçada usada {api.pct(calcAtivo.alcada_usada_pct)} de {api.pct(max)}</>}
                    {!semAlcada && cenarios.length > 1 ? ` · maior entre os cenários: ${api.pct(alcadaUsada)}` : ''}
                  </div>
                )}
              </div>
            )}
            {acimaDaAlcada && !coordenador && (
              <div className={classes.aviso}>Desconto + juros absorvidos acima de {api.pct(max)}: ao gerar, a proposta vai para aprovação do coordenador antes de o link mostrar estes valores.</div>
            )}

            <div className={classes.acoes}>
              <Button variant="contained" color="primary" disabled={salvando} onClick={() => salvar(true)}>
                {proposta && proposta.versao_publicada ? 'Salvar nova versão e publicar' : 'Gerar link'}
              </Button>
              <Button variant="outlined" disabled={salvando} onClick={() => salvar(false)}>Salvar rascunho</Button>
              <Button variant="outlined" disabled={salvando} onClick={abrirMinuta}>Minuta do contrato</Button>
              {proposta && proposta.status === 'aguardando_aprovacao' && coordenador && (
                <Button variant="contained" style={{ background: '#EE9E00', color: '#14142A' }} disabled={salvando} onClick={aprovarDesconto}>Aprovar desconto</Button>
              )}
              {salvando && <CircularProgress size={20} />}
              <span style={{ color: '#1F9833', fontWeight: 700, fontSize: 13 }} aria-live="polite">{copiado}</span>
            </div>

            {proposta && proposta.status === 'aguardando_aprovacao' && (
              <div className={classes.aviso}>Aguardando aprovação do desconto por um coordenador.{proposta.versao_publicada ? ' Enquanto isso, o link mostra a versão anterior.' : ' O link só abre depois da aprovação.'}</div>
            )}
            {link && (
              <div className={classes.linkbox}>
                <strong>Link único da proposta</strong>
                <code className={classes.codigo}>{link}</code>
                <div className={classes.acoes} style={{ marginTop: 0 }}>
                  <Button size="small" variant="outlined" onClick={() => copiar(link, 'Link')}>Copiar link</Button>
                  <Button size="small" variant="outlined" onClick={() => copiar(api.mensagemWhatsapp({ cliente: deal.person && deal.person.name, vendedor: user && user.name && user.name.split(' ')[0], calculo: (calculo || {}), link }), 'Mensagem')}>Copiar mensagem do WhatsApp</Button>
                  <Button size="small" variant="outlined" href={`${link}#interno`} target="_blank" rel="noopener">Abrir como o cliente</Button>
                  <Button size="small" variant="outlined" href={`${link}#interno,pdf`} target="_blank" rel="noopener">Ver PDF</Button>
                  {proposta.venda_id
                    ? <Button size="small" variant="contained" color="primary" component={Link} to={`/nova-venda/${proposta.venda_id}`}>Abrir venda</Button>
                    : <Button size="small" variant="contained" color="primary" disabled={salvando} onClick={() => virarVenda()}>Virar venda</Button>}
                </div>
                <p className={classes.dica}>"Abrir como o cliente" e "Ver PDF" não contam como abertura. "Virar venda" abre a Nova venda já com plano e requerentes; você confere e segue o escopo normal.</p>
              </div>
            )}
          </Paper>
        </div>

        <aside className={classes.previa} aria-label="Prévia da proposta no celular">
          <div className={classes.celular}>
            {cat && <iframe ref={iframe} title="Prévia da proposta" src={`${cat.url_publica}/preview`} style={{ width: '100%', height: '100%', border: 0 }} onLoad={() => ultimaPagina.current && enviarPrevia(ultimaPagina.current)} />}
          </div>
          <p style={{ textAlign: 'center', color: '#64688B', fontSize: 12, margin: '8px 0 0' }}>Prévia ao vivo: é a página que o cliente abre (sem número até gerar o link).</p>
        </aside>
      </div>
    </div>
  );
}

function resumoPlano(c) {
  if (!c) return '';
  if (c.plano === 'avulso') return ((c.avulsos || [])[0] || {}).titulo || 'serviço avulso';
  if (c.plano === 'analise') {
    const n = c.resumo.n_requerentes || 0;
    return `R$ 1.000${n > 1 ? ` + ${n - 1}×R$ 500` : ''}`;
  }
  if (c.resumo.modo === 'estado_civil') return `${c.resumo.n_adultos} pessoa(s) × R$ 3.000, só estado civil`;
  const a = c.resumo.n_adultos || 0;
  return `${a} adulto${a !== 1 ? 's' : ''} pela tabela${c.resumo.n_menores ? ` + ${c.resumo.n_menores}×${api.brl(c.resumo.valor_por_menor)} (menor)` : ''}`;
}

export default connect(null, { notify: showNotification })(NovaProposta);
